// Use user agent to detect Safari browser
// https://stackoverflow.com/questions/7944460/detect-safari-browser
export const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// Use user agent to detect IOS browser
export const isIOSBrowser = (deviceType: string) =>
  /iPhone|iPad|iPod/i.test(deviceType);
